const initialState={
    isLoading:'true',
    details:"",
    name:"",
    address:"",
    phone:"",
    pincode:"",
    image:"",
}
export default initialState;